import React from "react";
import styles from "./pdf.module.css";
import ResultCard from "../InflationCalculatorResult";


const formatIndianNumber = (num) => {
  return Number(num).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const InflationReport = (props) => { 
  const { form,resultCard } = props;  
  return (
    <div>
      {/* Header */}
      <div className={styles.pdf_child_container}>
        <div className={styles.pdf_card}   style={{ paddingBottom: "1rem" }} >
        <h2 className={styles.pdf_title}>Inflation Calculator Report</h2> 
        {/* Investment Parameters */}
        <div className={styles.pdf_section}>INPUT DETAILS</div>

        <table className={styles.pdf_input_table}>
          <tr>
            <th>
             Particulars
            </th>
            <th>
              Details
            </th>
          </tr>
          <tr>
            <td>
              Monthly Expenditure - Present
            </td>
            <td>
             ₹{" "} {formatIndianNumber(form.monthlyExp)}
            </td>
          </tr>
          <tr>
            <td>
             Inflation
            </td>
            <td>
             {(form.inflation)}%
            </td>
          </tr>
          <tr>
            <td>
             Present Age
            </td>
            <td>
              {(form.presentAge)} Years
            </td>
          </tr>
           <tr>
            <td>
            Retirement Age
            </td>
            <td>
              {(form.retirementAge)} Years
            </td>
          </tr>
        </table>
        <div className={styles.pdf_result_header}>
        <div className={styles.pdf_section}>SUMMARY</div>
        <div className={styles.pdf_section_light}>
          Generated on {new Date().toLocaleDateString()}
        </div>
        </div>
        <ResultCard results={resultCard}/>
        <p className={styles.pdf_declaration}>* The above values are estimated based on the assumed rate of return and may vary with market conditions.</p>
        </div>
      </div>
    </div>
  );
};

export default InflationReport;